/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocaleEndpointResponse
 */
export interface LocaleEndpointResponse {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof LocaleEndpointResponse
     */
    strings: { [key: string]: string | undefined; };
}

export function LocaleEndpointResponseFromJSON(json: any): LocaleEndpointResponse {
    return LocaleEndpointResponseFromJSONTyped(json, false);
}

export function LocaleEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocaleEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'strings': json['strings'],
    };
}

export function LocaleEndpointResponseToJSON(value?: LocaleEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'strings': value.strings,
    };
}


